<p-toast></p-toast>
<div *ngIf="redimir" class="container" style="width: 50%; margin: auto;">
    <h2 style="text-align: center;">Informacion de Canje</h2>
    <table>
        <thead class="thead-light">
            <tr>
                <th scope="col" colspan="2" class="text-center">CANJE</th>
            </tr>
        </thead>
        <tbody *ngIf="redimir">
            <tr>
                <td class="font-weight-bold">Fecha:</td>
                <td>{{ redimir.fechaInicio | date: 'dd/MM/yyyy' }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold">Cantidad:</td>
                <td>{{ redimir.redimir | number: '1.0':'en-US' }}</td>
            </tr>
            <tr>
                <td>
                    <span
                        [ngClass]="{'text-danger': redimir.status === 2 || redimir.status === 4, 'text-success': redimir.status === 3}">
                        Status: </span>
                </td>
                <td>
                    <span
                        [ngClass]="{'text-danger': redimir.status === 2 || redimir.status === 4, 'text-success': redimir.status === 3}">{{
                        getDescripcion() | uppercase }} </span>
                </td>
            </tr>
            <tr>
                <td class="font-weight-bold">Aplicación:</td>
                <td>{{ redimir.fechaFinal | date: 'dd/MM/yyyy' }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold">Observación:</td>
                <td> {{redimir.observacion}} </td>
            </tr>
        </tbody>
    </table>

    <table>
        <thead>
            <tr>
                <th colspan="3">CASOS CLINICOS</th>
            </tr>
            <tr>
                <th>#</th>
                <th>Serie</th>
                <th>Hospital</th>
            </tr>
        </thead>
        <tbody *ngIf="redimir">
            <tr *ngFor="let casoclinico of redimir.casosclinicos; let i=index">
                <td>{{i+1}}</td>
                <td>{{casoclinico.serie}}</td>
                <td>{{casoclinico.nomHospital}}</td>
            </tr>
        </tbody>
    </table>

    <table>
        <thead>
            <tr>
                <th colspan="2">
                    Referencias del CANJE
                </th>
            </tr>
        </thead>
        <tbody *ngIf="redimir">
            <tr *ngFor="let ref of redimir.referencias; let i = index">
                <td>
                    Referencia {{i+1}}
                </td>
                <td>
                    <span *ngIf="ref.rutaPublica">
                        <a [href]="urlbase + ref.rutaPublica + '/' + ref.filename" target="_blank">
                            <i class="fa fa-file-archive-o fa-lg" aria-hidden="true"></i>
                        </a>
                    </span>
                </td>
            </tr>
        </tbody>
    </table>

</div>